/**
 * How far a tall section has travelled past its sticky stage: 0 while its top is at or below the top of the window,
 * 1 once its bottom meets the bottom of the window.
 */
export function scrollProgress(top: number, height: number, viewport: number): number {
  const travel = height - viewport;
  if (travel <= 0) return top < 0 ? 1 : 0;
  return clamp(-top / travel);
}

/** The share of `p` between `from` and `to`: 0 before, 1 after. */
export function segment(p: number, from: number, to: number): number {
  return clamp((p - from) / (to - from));
}

/** Slow at both ends, the movement of the page (`--ease-move` in styles.css). */
export function easeInOut(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
}

/** The phase a progress is in, given the thresholds that open each phase after the first. */
export function phaseOf(p: number, thresholds: readonly number[]): number {
  return thresholds.filter((threshold) => p >= threshold).length;
}

const clamp = (value: number) => Math.min(1, Math.max(0, value));
